import React from 'react';

import { Button, ButtonGroup, Heading, Paragraph, Text, TextButton } from '@zillow/constellation-10';

import LeaseModal from '../../Containers/LeaseModal';
import type { LeaseActionProps } from '../../../../shared/models/Types';
import FaqAccordion from '../../Widgets/FaqAccordion';

type Props = LeaseActionProps;

const FAQ_SECTIONS = [
  {
    label: 'How can my renters and I sign the lease?',
    description: (
      <Text>
        Once you finish creating a draft of your lease, request signatures from your leases dashboard. Next choose{' '}
        <strong>Sign online</strong> to sign electronically, or you can print out copies of the lease and arrange for a
        signing.
      </Text>
    ),
  },
  {
    label: 'How do I share a draft with people who aren’t my tenants, such as my lawyer?',
    description: (
      <Text>
        After you finish creating a draft of your lease, download a PDF. You can email or text that file to your
        recipients. If you prefer, you can also print a copy and share it via regular mail or in person.
      </Text>
    ),
  },
];

export default function OpenModalRequestSignaturesBlocker({
  history,
  lease,
  terminateActiveAction,
}: Props): JSX.Element {
  function onEditLease(): void {
    terminateActiveAction();
    history.push(lease.getSummaryPath());
  }

  return (
    <LeaseModal
      header={<Heading level={1}>Your lease is not complete</Heading>}
      isOpen
      onClose={terminateActiveAction}
      body={
        <>
          <Paragraph css={{ marginBottom: 'tight' }}>
            To download a draft or to share one with your renters, complete the fields that need more info.
          </Paragraph>
          <FaqAccordion title="You may be wondering…" sections={FAQ_SECTIONS} />
        </>
      }
      footer={
        <ButtonGroup aria-label="finish lease">
          <TextButton tone="brand" onClick={terminateActiveAction}>
            Cancel
          </TextButton>
          <Button tone="brand" emphasis="filled" onClick={onEditLease}>
            Finish creating lease
          </Button>
        </ButtonGroup>
      }
    />
  );
}
